import { render, staticRenderFns } from "./TheOrderManagement.vue?vue&type=template&id=df4089ba&scoped=true"
import script from "./TheOrderManagement.vue?vue&type=script&lang=js"
export * from "./TheOrderManagement.vue?vue&type=script&lang=js"
import style0 from "./TheOrderManagement.vue?vue&type=style&index=0&id=df4089ba&prod&lang=css"
import style1 from "./TheOrderManagement.vue?vue&type=style&index=1&id=df4089ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4089ba",
  null
  
)

export default component.exports